import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { generateFormattedHTML, getPrivacyPolicyWebsiteUrl } from '../utils';
import Button from './Button';
import Modal from './Modal';
import file from '../resources/file';

const PrivacyPolicyModal = ({ confirmModalOpen, setConfirmModalOpen, countryCode }) =>{
  const { t, i18n } = useTranslation();
  const [ policyData, setPolicyData ] = useState(null);

  useEffect(() => {
    if (countryCode) {
      file.fetchPrivacyPolicy(getPrivacyPolicyWebsiteUrl(countryCode, t)).then(data=>{
        setPolicyData(generateFormattedHTML(data, 'contentpage__inner'));
      });
    }
  }, [ countryCode, i18n.language ]);

  return (<>
    <Modal
      visible={confirmModalOpen}
      centered={true}
      padding="10px"
      width="900px"
      className="policy-modal"
      footer={[
        <Button key="close" type="primary" onClick={() => {
          setConfirmModalOpen(false);
        }}>
          {t('close')}
        </Button>,
      ]} onCancel={() => {
        setConfirmModalOpen(false);
      }}>
      {policyData &&
        <div className="policy-content" dangerouslySetInnerHTML={{ __html: policyData }}></div>
      }
    </Modal>
  </>);
};

export default PrivacyPolicyModal;


